/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { getByIdAsync } from "@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g";
import * as Msdyn365 from "@msdyn365-commerce/core";

var qs = require("qs");

/**a
 * BritaxGetAssets Input Action
 */

export interface BritaxGetAssetsInput {
  productId: string;
}

export class BritaxGetAssetsInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor() {}

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `assets`;
  public getCacheObjectType = () => "assets";
  public dataCacheType = (): Msdyn365.CacheType => "request";
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IBritaxGetAssetsData {
  text: string;
}

export interface IToken {
  token_type: string;
  expires_in: string;
  ext_expires_in: string;
  expires_on: string;
  not_before: string;
  resource: string;
  access_token: string;
}
export interface CheckedoutToCriteria {
  locales: string[];
  markets: any[];
  targets: string[];
  experiments: any[];
}

export interface PropertyBag {
  keywords: string[];
  name: string;
}

export interface Thumbnail {
  href: string;
  height: number;
  width: number;
}

export interface BinaryReference {
  href: string;
  contentType: string;
  extension: string;
  clientHref: string;
  format: string;
}

export interface ProcessingStatus {
  message: string;
  status: string;
}

export interface BinaryMetadata {
  forceUserDownload: boolean;
  copyright: string;
  contentType: string;
  extension: string;
  binaryId: string;
  playtime?: number;
  title: string;
  minimumAge?: number;
  thumbnail: Thumbnail;
  binaryReferences: BinaryReference[];
  captions: any[];
  transcripts: any[];
  descriptiveAudioTrack: any[];
  regularAudioTrack: any[];
  processingStatus: ProcessingStatus;
}

export interface Asset {
  type: string;
  lastModified: Date;
  lastModifiedBy: string;
  id: string;
  cmsId: string;
  state: string;
  checkedoutTo: string;
  isCheckedOutToMe: boolean;
  checkedoutToLocale: string;
  checkedoutToMarket: string;
  checkedoutToCriteria: CheckedoutToCriteria;
  isPublished: boolean;
  errorDetails: string;
  publicUrl: string;
  previewUrl: string;
  propertyBag: PropertyBag;
  binaryMetadata: BinaryMetadata;
  processingStatus: string;
  sourceUrl: string;
  thumbnailUrl: string;
}

export interface FeatureFlags {
  isPublishAuthorizationEnabled: boolean;
  isImagePublishBlocked: boolean;
  isFilePublishBlocked: boolean;
  isVideoPublishBlocked: boolean;
  isManualBinaryLocalizationEnabled: boolean;
}

export interface IRootAssets {
  totalAssets: number;
  assets: Asset[];
  assetMetadataType: string;
  isReleaseGroupLocked: boolean;
  featureFlags: FeatureFlags;
  siteDisplayName: string;
  supportedExtensions: string[];
  isVideoEnabled: boolean;
}

export interface ISecretValue {
  value: string; // secret value
  id?: string; // secret ID (if applicable)
  error?: Error; // Error details (set if request to fetch secret value failed)
  expiresOn: number; // Unix timestamp (in seconds) when the secret value will expire
}
/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new BritaxGetAssetsInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
  input: BritaxGetAssetsInput,
  ctx: Msdyn365.IActionContext
): Promise<any> {
  var pID = parseInt(ctx.requestContext.urlTokens?.recordId!);
  const res = await getByIdAsync(
    { callerContext: ctx, bypassCache: "none" },
    pID,
    ctx.requestContext.apiSettings.channelId
  );
  const baseProduct = Array.isArray(res) ? res[0] : res;
  const product = { ...baseProduct };

  const response = await getToken(ctx);
  const assets = await getAssets(
    ctx,
    response.data.access_token,
    product.ItemId
  );
  return assets;
}

async function getToken(ctx: any) {
  // const grantType: ISecretValue | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue('granttype', ctx.requestContext.apiSettings.baseUrl);
  // const clientId: ISecretValue | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue('clientid', ctx.requestContext.apiSettings.baseUrl);
  // const clientSecret: ISecretValue | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue('clientsecret', ctx.requestContext.apiSettings.baseUrl);
  // const resource: ISecretValue | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue('resource', ctx.requestContext.apiSettings.baseUrl);
  // const scope: ISecretValue | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue('scope', ctx.requestContext.apiSettings.baseUrl);
  var data = qs.stringify({
    grant_type: "client_credentials",
    client_id: ctx.requestContext.app.config.clientId,
    client_secret: ctx.requestContext.app.config.clientSecret,
    resource: "3530b95b-aca8-4164-b78e-0c07cbfd0681",
    scope: ".default",
  });
  const reponse = await Msdyn365.sendRequest<IToken>(
    "https://login.microsoftonline.com/6d56f056-48d8-4e5a-a528-0e2df50d29ac/oauth2/token",
    "post",
    data,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie:
          "fpc=AopThjyphGZIqV8tMvZOskskZZdbAQAAAETfudgOAAAA; stsservicecookie=estsfd; x-ms-gateway-slice=estsfd",
      },
    }
  );
  return reponse;
}
async function getAssets(ctx: any, token: any, postBody: any) {
  //const EnvBaseUrl: ISecretValue | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue('Env_UAT', ctx.requestContext.apiSettings.baseUrl);
  //'https://manage.commerce.dynamics.com/assets-api-mrprod-eu/v1/britax-uat/sites/ME3Op/assets/search?targets=ecommercechannelid%7Crpbpwaytjjr&$searchBy=asset.name:'
  const reponse = await Msdyn365.sendRequest<IRootAssets>(
    ctx.requestContext.app.config.assetsApiURL + postBody,
    "get",
    "",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return reponse.data;
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<any>>action,
  // TODO: Give your data action a unique id
  id: "BritaxGet",
  input: createInput,

  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
